import { ColumnConfigType } from 'shared/types';
import { IOTPItem } from 'entities/sendOTP/types';

export const columnConfig: ColumnConfigType<IOTPItem>[] = [
  {
    dataFieldName: 'displayed_name',
    name: 'Способ отправки',
    width: '30%',
  },
  {
    dataFieldName: 'priority',
    name: 'Приоритет',
    width: '10%',
  },
  {
    dataFieldName: 'limit_per_day',
    name: 'Лимит на пользователя в сутки',
    width: '10%',
  },
  {
    dataFieldName: 'retry_time',
    name: 'Минуты до запроса нового ОТР',
    width: '10%',
  },
  {
    dataFieldName: 'limit_per_month',
    name: 'Лимит на пользователя в месяц',
    width: '10%',
  },
  {
    dataFieldName: 'is_enabled',
    name: 'Включено',
    width: '10%',
  },
];
